import { Link, useNavigate } from "react-router-dom";
import axios from 'axios'
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {Helmet} from "react-helmet";

const Login = () => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const { t } = useTranslation()
    
    useEffect(() => {
        // Check if user and token exist in localStorage
        const user = localStorage.getItem("parent_user")
        const token = localStorage.getItem("parent_token")

        if (user && token) {
            navigate("/profile")
        }
    }, [navigate])


    const submitForm = async (values:any) => {
        localStorage.removeItem("parent_token")
        localStorage.removeItem("parent_user")
        localStorage.removeItem("selectedStudent")
        setLoading(true)
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/login`, {
            email: values.email,
            password: values.password,
            role:"parent"
        }).then( res => {
            console.log("res", res)
            localStorage.setItem("parent_user", JSON.stringify(res.data.user))
            localStorage.setItem("parent_token", res.data.token)
            localStorage.setItem("role", "parent")
            navigate("/profile")
        }).catch( err => {
            console.log("err", err)
            if (err && err.response && err.response.data && err.response.data.error) {
                toast.error(err.response.data.error)
            } else {
                toast.error("Invalid credentials")
            }
        }).finally(()=>{
            setLoading(false)
        })
    }

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .email(t("validation.invalid_email"))
            .required(t("validation.required")),
        password: Yup.string()
            .min(6, t("validation.password_min"))
            .required(t("validation.required")),
    })

    return (
    <>
        <Helmet>
            <title>Best Talent Class Management System in Malaysia – MyKoku</title>
            <meta name="description" content="Find talent class - Badminton, Swimming, STEM, Magic, Chess and more! Content trusted by schools across Malaysia SK, SJKC, SMK & SMJK." />
        </Helmet>

        <div className="pt-4 px-4 h-screen ">
            <div className="mb-10">
                <div className="px-0">
                    <img src={process.env.PUBLIC_URL + "/assets/img/koku.png"} className="w-20" alt="" />
                    <div className="flex">
                        <h3 className="text-2xl font-bold text-black self-center">{t('login.parent_login')}</h3>
                    </div>
                </div>
            </div>

            <div className="px-0">
                <Formik
                    initialValues={{ email: "", password: "" }}
                    validationSchema={validationSchema}
                    onSubmit={(values, { setSubmitting }) => {
                        submitForm(values)
                            .finally(() => {
                                setSubmitting(false)
                            })
                    }}
                >
                {({ isSubmitting }) => (
                    <Form>
                        <div className="mb-7">
                            <label htmlFor="email" className="text-sm font-medium text-black block mb-2">{t("login.email")}</label>
                            <Field
                                type="text"
                                name="email"
                                id="email"
                                placeholder={t("login.enter_email")}
                                className="w-full text-lg text-black border-b-2 border-gray-300 focus:border-theme outline-none py-2"
                            />
                            <ErrorMessage name="email" component="div" className="mt-1 text-red-500 text-sm" />
                        </div>

                    <div className="mb-7">
                        <label htmlFor="password" className="text-sm font-medium text-black block mb-2">{t("login.password")}</label>
                        <Field
                            type="password"
                            name="password"
                            id="password"
                            placeholder={t("login.enter_password")}
                            className="w-full text-lg text-black border-b-2 border-gray-300 focus:border-theme outline-none py-2"
                        />
                        <ErrorMessage name="password" component="div" className="mt-1 text-red-500 text-sm" />
                    </div>

                    <div className="mb-3 text-sm text-gray-500">
                        {t("login.dont_have_account")}{" "}
                        <Link to="/register" className="text-theme">{t("login.sign_up_now")}</Link>
                    </div>

                    <div className="mb-7 text-sm text-gray-500">
                        {t("login.forget_password")}{" "}
                        <Link to="/reset-password" className="text-theme">{t("login.reset_password")}</Link>
                    </div>

                    <button
                        type="submit"
                        className="text-white text-[16px] leading-none w-full py-[15px] bg-theme border-none rounded-3xl flex items-center justify-center"
                        disabled={isSubmitting || loading}
                    >
                        {loading ? <FaSpinner className="animate-spin" /> : t("login.login")}
                    </button>

                    <div className="grid w-3/6 my-4 px-2 float-right">
                        <select
                            className="px-2 py-1 border rounded-full text-md bg-white focus:outline-none focus:ring-2 focus:ring-theme appearance-none"
                            onChange={(e) => {
                                i18next.changeLanguage(e.target.value);
                            }}
                        >
                        <option value="-1" disabled selected>-- Language --</option>
                        <option value="en">English</option>
                        <option value="zh">Mandarin</option>
                        <option value="ms">Bahasa</option>
                        </select>
                    </div>
                    </Form>
                )}
                </Formik>
            </div>
        </div>
    </>
    )
}

export default Login;
